<p-toast></p-toast>
<div class="p-3" [formGroup]="availabilityForm">
  <div class="page-title d-flex align-items-start px-1 gap-4 justify-content-between">
    <div class="d-flex flex-column align-items-start">
      <h3>Availability Settings</h3>
      <p>Set your weekly availability. These time slots will be visible to visitors when scheduling or rescheduling
        tours. Days marked as "Not Available" will not appear to visitors.</p>
    </div>
    <div class="d-flex align-items-center gap-3 ms-auto">
      <div class="d-flex flex-column align-items-end gap-1">
        <small class="text-muted fw-semibold" style="font-size:11px;letter-spacing:0.05em;text-transform:uppercase;">Availability Mode</small>
        <p-selectButton
          [options]="availabilityModeOptions"
          [(ngModel)]="availabilityMode"
          [ngModelOptions]="{standalone: true}"
          optionLabel="label"
          optionValue="value">
        </p-selectButton>
      </div>
      <!-- <div class="form-group p-0 d-flex align-items-center gap-1">
        <label>Interval</label>
        <p-dropdown [options]="intervalOptions" formControlName="interval"></p-dropdown>
      </div> -->
    </div>
  </div>

  <div class="action-buttons mt-3 mb-3">
    <!-- <p-button pButton label="Cancel" class="secondary-btn" (click)="onCancel()"></p-button> -->
    <p-button pButton label="Save Availability" class="primary-btn" [disabled]="submitting" (click)="onSubmit()"></p-button>
  </div>

  <div class="card">
    <div class="card-body">
      <p-accordion [activeIndex]="0">
        <p-accordionTab *ngFor="let day of days">
          <ng-template pTemplate="header">
            <span class="me-auto">{{ day.label }}</span>
            <span (click)="$event.stopPropagation()" class="accordionSwitch">
              <p-inputSwitch [formControl]="getUnavailableControl(day.name)"
              (onChange)="toggleUnavailable(day.name, $event.checked)">
              </p-inputSwitch>
              <small>Not Available</small>
            </span>
          </ng-template>

          <div class="d-flex flex-column align-items-start">
            <div [formArrayName]="day.name" class="w-100">
              <div class="slot-row w-100" *ngFor="let slot of getSlots(day.name).controls; let i = index" 
                   [formGroupName]="i">
                <!-- <span>
                  <div class="text-red-500" *ngIf="slot.errors?.['invalidRange']">
                    {{ slot.errors?.['invalidRange'] }}
                  </div>
                  <div class="text-red-500" *ngIf="slot.errors?.['overlap']">
                    {{ slot.errors?.['overlap'] }}
                  </div>
                </span> -->
                <p-calendar [disabled]="isDayUnavailable(day.name)"
                    [showIcon]="true" 
                    [iconDisplay]="'input'"
                    formControlName="start" 
                    timeOnly="true"
                    hourFormat="12" 
                    placeholder="Start"
                    [stepMinute]="intervalValue"
                    readonlyInput="true"
                    inputmode="none">
                </p-calendar>

                <span *ngIf="!isDayUnavailable(day.name)" class="mx-1">to</span>

                <p-calendar [disabled]="isDayUnavailable(day.name)"
                    [showIcon]="true" 
                    [iconDisplay]="'input'"
                    formControlName="end" 
                    timeOnly="true"
                    hourFormat="12" 
                    placeholder="End"
                    [stepMinute]="intervalValue"
                    (onSelect)="onTimeChange($event)"
                    readonlyInput="true"
                    inputmode="none">
                </p-calendar>

                <p-button
                    pButton icon="pi pi-trash" 
                    class="icon-primary-btn" 
                    (click)="removeSlot(day.name, i)"
                    [disabled]="isDayUnavailable(day.name)">
                </p-button>
              </div>
            </div>

            <p-button 
                icon="pi pi-plus" 
                class="secondary-btn ms-auto" 
                (click)="addPropertySlot(day.name)" 
                label="Add Slot"  
                size="small"
                [disabled]="isDayUnavailable(day.name)">
            </p-button>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>

  <div class="availability-container">
    <div class="action-buttons mt-3 mb-3">
      <p-button pButton label="Save Availability" class="primary-btn" [disabled]="submitting" (click)="onSubmit()"></p-button>
    </div>
  </div>
</div>
